import { useTranslation } from 'react-i18next'
import { Save } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { BackButton } from '@/components/ui/BackButton'
import { useOrgNavigate } from '@/hooks/use-app-navigate'

interface ProcessorEditHeaderProps {
    processorId: string
    title: string
    onCancel: () => void
    onSave: () => void
    isSaving?: boolean
}

export const ProcessorEditHeader = ({
    processorId,
    title,
    onCancel,
    onSave,
    isSaving = false,
}: ProcessorEditHeaderProps) => {
    const { t } = useTranslation('processors')
    const { orgRoutes } = useOrgNavigate();
    return (
        <div className="mb-6 flex items-center justify-between">
            <div className="flex items-center gap-2">
                <BackButton to={orgRoutes.PROCESSOR_DETAILS(processorId)} />
                <h1 className="text-3xl font-bold">{title}</h1>
            </div>
            <div className="flex gap-2">
                <Button variant="outline" onClick={onCancel}>
                    {t('cancel')}
                </Button>
                <Button onClick={onSave} disabled={isSaving}>
                    <Save className="mr-2 h-4 w-4" />
                    {isSaving ? t('saving') : t('saveChanges')}
                </Button>
            </div>
        </div>
    )
}

